import React from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

import cls from './AuthorizationSwiper.module.scss';
import firstSlide from 'src/assets/img/login-slide-1.png';
import secondSlide from 'src/assets/img/login-slide-2.png';
import thirdSlide from 'src/assets/img/login-slide-3.jpg';
import fourthSlide from 'src/assets/img/login-slide-4.jpg';

const AuthorizationSwiper = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'auth-slider' });

  return (
    <div className={cls['swiper']}>
      <Swiper
        className={cls['swiper-wrapper']}
        centeredSlides={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Autoplay]}
      >
        <SwiperSlide className={cls['swiper-slide']}>
          <img
            src={firstSlide}
            alt="First slide background"
            className={cls['swiper-slide-img']}
          />
          <div className={cls['swiper-slide-text-wrapper']}>
            <h2 className={cls['swiper-slide-text']}>{t('t-first-title')}</h2>
            <p className={cls['swiper-slide-description']}>
              {t('t-first-description')}
            </p>
            <a
              href="https://profi-crm.com/"
              className={`${cls['swiper-slide-description']} text-underline cursor-pointer`}
            >
              {t('t-first-link')}
            </a>
          </div>
        </SwiperSlide>
        <SwiperSlide className={cls['swiper-slide']}>
          <img
            src={secondSlide}
            alt="Second slide background"
            className={cls['swiper-slide-img']}
          />
          <div className={cls['swiper-slide-text-wrapper']}>
            <h2 className={cls['swiper-slide-text']}>{t('t-first-title')}</h2>
            <p className={cls['swiper-slide-description']}>
              {t('t-first-description')}
            </p>
            <a
              href="https://profi-crm.com/"
              className={`${cls['swiper-slide-description']} text-underline cursor-pointer`}
            >
              {t('t-first-link')}
            </a>
          </div>
        </SwiperSlide>
        <SwiperSlide className={cls['swiper-slide']}>
          <img
            src={thirdSlide}
            alt="Second slide background"
            className={cls['swiper-slide-img']}
          />
          <div className={cls['swiper-slide-text-wrapper']}>
            <h2 className={cls['swiper-slide-text']}>{t('t-first-title')}</h2>
            <p className={cls['swiper-slide-description']}>
              {t('t-first-description')}
            </p>
            <a
              href="https://profi-crm.com/"
              className={`${cls['swiper-slide-description']} text-underline cursor-pointer`}
            >
              {t('t-first-link')}
            </a>
          </div>
        </SwiperSlide>
        <SwiperSlide className={cls['swiper-slide']}>
          <img
            src={fourthSlide}
            alt="Second slide background"
            className={cls['swiper-slide-img']}
          />
          <div className={cls['swiper-slide-text-wrapper']}>
            <h2 className={cls['swiper-slide-text']}>{t('t-first-title')}</h2>
            <p className={cls['swiper-slide-description']}>
              {t('t-first-description')}
            </p>
            <a
              href="https://profi-crm.com/"
              className={`${cls['swiper-slide-description']} text-underline cursor-pointer`}
            >
              {t('t-first-link')}
            </a>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default AuthorizationSwiper;
